// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");
var $ = require("./lib/qsa");

var showMax = 15;

var school_selector = document.getElementById("school-selector");
var year_selector = document.getElementById("year-selector");
var violation_selector = document.getElementById("violation-selector");
var finding_selector = document.getElementById("finding-selector");

function isMatch(value, expected) {
  value = value.toString().trim();
  return value == expected || expected == 'All';
}

function updateTableEvent(e) {
  e.preventDefault();
  updateTable();
}

function updateTable() {
  var school = school_selector.value;
  var year = year_selector.value;
  var violation = violation_selector.value;
  var finding = finding_selector.value;

  var table = table = document.getElementById("table");
  var tr = table.getElementsByClassName("school-row");

  var totalMatches = 0;
  for (i = 0; i < tr.length; i++) {
    var match =
      isMatch(tr[i].dataset.school, school) &&
      isMatch(tr[i].dataset.year, year) &&
      (isMatch(tr[i].dataset.violation, violation) ||
      isMatch(tr[i].dataset.violation2, violation) ||
      isMatch(tr[i].dataset.violation3, violation) ||
      isMatch(tr[i].dataset.violation4, violation) ||
      isMatch(tr[i].dataset.violation5, violation)) &&
      isMatch(tr[i].dataset.finding, finding);

    if (match) {
      tr[i].style.display = "";
      totalMatches++;
    }
    
    if (!match || totalMatches >= showMax) {
      tr[i].style.display = "none";
    }
  }

  if (totalMatches < showMax) {
    $.one(".facilities").classList.remove("collapsed");
  } else {
    $.one(".facilities").classList.add("collapsed");
  }
}

school_selector.addEventListener('change', updateTableEvent);
year_selector.addEventListener('change', updateTableEvent);
violation_selector.addEventListener('change', updateTableEvent);
finding_selector.addEventListener('change', updateTableEvent);

// update for first load
updateTable();

var uncollapseButton = $.one(".uncollapse");
var uncollapse = function uncollapse() {
  $.one(".facilities").classList.remove("collapsed");
  showMax = Number.MAX_VALUE;
  updateTable();
};
uncollapseButton.addEventListener("click", uncollapse);
uncollapseButton.addEventListener("keydown", (ev) => {
  // enter or spacebar, mimicking <button>'s behavior
  if (ev.keyCode === 13 || ev.keyCode === 32){
    ev.preventDefault(); // avoid, e.g., scroll down on spacebar
    uncollapse();
  }
});
